import { render, staticRenderFns } from "./DeleteAccountProgressBar.vue?vue&type=template&id=6ec31f24&scoped=true"
import script from "./DeleteAccountProgressBar.vue?vue&type=script&lang=js"
export * from "./DeleteAccountProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec31f24",
  null
  
)

export default component.exports